import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
 
import ConectUs from "../../components/ConectUs";
 
import { motion } from "framer-motion";
import logo from "../../img/logo-escuela-de-negocio.png";
import OfferEscuelaNegocios from "../../components/view/OfferEscuelaNegocios";
 
 
import SegundaTitulacionEscuelaNegocios from "./SegundaTitulacionEscuelaNegocios";
import SemanasInternacionalesEscuelaNegocios from "./SemanasInternacionalesEscuelaNegocios";
 
import DescuentosEscuelaNegocios from "./DescuentosEscuelaNegocios";
import Modal from "../../components/Modal";
import ImageGallery from "../../components/ImageGallery";

const processContent = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");

    if (src && !src.startsWith("http")) {
      img.setAttribute(
        "src",
        `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
      );
    }
  });

  return doc.body.innerHTML;
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  },
};

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/fc73f51f-b473-4dae-92c2-47ddbbcfb02d" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function EscuelaNegocios() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => {
    const hasGallery = Array.isArray(data?.galeria)
      ? data.galeria.length > 0
      : Boolean(data?.galeria);
    return (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <>
            <div className="w-60 h-60 flex items-center justify-center">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />{" "}
          </>
        }
      />

        {/* Sección matricula */}
        <section className="mt-4 px-4 flex justify-center">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="w-full max-w-3xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 p-8 md:p-10 flex flex-col items-center text-center gap-6"
          >
            {/* Texto y Botones (Estilo 100% estático, sin condicionales) */}
            <div
              dangerouslySetInnerHTML={{ __html: data.bloque1 }}
              className="w-full flex flex-col items-center text-center  
                /* Párrafos */
                [&_p]:text-slate-200
                        
                [&_h4]:text-[#febe10]
                  [&_h4]:mt-6
                 [&_h4]:text-lg
                [&_h4_strong]:text-lg
                 [&_h4]:p-0

                /* Título Principal h2 */
               
                [&_h2]:text-white
               [&_h2]:p-0
                [&_h2_strong]:text-white

                   [&_h3]:text-white
                      [&_h3_strong]:text-white

                /* Botón de acción principal */
                [&_a]:inline-flex
                [&_a]:items-center
                [&_a]:justify-center
                [&_a]:px-7
                [&_a]:py-3.5
                [&_a]:mt-4
                [&_a]:text-sm
                [&_a]:font-bold
                [&_a]:text-slate-950
                [&_a]:bg-[#febe10]
                [&_a]:hover:bg-[#e0a60b]
                [&_a]:rounded-xl
                [&_a]:shadow-md
                [&_a]:transition-all
                [&_a]:duration-200
                [&_a]:hover:scale-105
                [&_a]:mx-auto
              "
            />

            {/* Modal / Galería: solo se monta si existen elementos */}
            {hasGallery && (
              <div className="pt-4 border-t border-white/10 w-full flex justify-center [&_button]:text-white   [&_button]:font-bold [&_button:hover]:text-[#febe10] ">
                <Modal
                  title="Proceso de matrícula"
                  content={
                    <div className="max-w-[350px] m-auto">
                      {" "}
                      <ImageGallery gallery={data.galeria} />
                    </div>
                  }
                />
              </div>
            )}
          </motion.div>
        </section>
     
      <div className="pb-16 pt-4">
        <OfferEscuelaNegocios></OfferEscuelaNegocios>
      </div>

      <SemanasInternacionalesEscuelaNegocios />

      <SegundaTitulacionEscuelaNegocios />

      <DescuentosEscuelaNegocios></DescuentosEscuelaNegocios>

{data.bloque3&&(

  <section className="py-24 bg-slate-50">
        <div className="max-w-6xl m-auto  px-6">
          <div
            className="text-center
    [&_h2]:text-gray-500 [&_h2_strong]:text-lg [&_h2_strong]:font-base
    
    [&_div]:inline-grid  [&_div]:m-3
    [&_img]:w-[110px] [&_img]:h-[110px] [&_img]:object-top [&_img]:object-cover [&_img]:rounded-full [&_img]:m-auto
  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque3),
            }}
          />

          <div
          className="link-with-arrow-1"
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque4),
            }}
          />
        </div>
      </section>
)}
    
    </div>
   );
  };
  return (
    <>

 
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="padding2">
        <ConectUs
          instagram="https://www.instagram.com/utplescueladenegocios"
          linkedin="https://www.linkedin.com/company/utplescueladenegocios"
          tiktok="https://www.tiktok.com/@utplescueladenegocios"
          facebook="https://www.facebook.com/utplescuelanegocios/"
        ></ConectUs>
      </div>
    </>
  );
}

export default EscuelaNegocios;
